import { exec, getApiToken } from '../utils';
import type {
  CatalogAttributesResponse,
  CatalogAttributesExecVariables,
  CatalogAttributesExecResponse
} from '@src/types';

export const catalogAttributes = async (
  partnerCode: string,
  token: string
): Promise<CatalogAttributesResponse> => {
  const apiToken = await getApiToken(token);

  const searchQuery = `
    query catalogAttributes(
      $partnerCode: String!
      $token: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          catalogAttributes {
            validDepartments
            validCategories
            validColors {
              code
              name
            }
            validGenders {
              code
              name
            }
            validSeasons {
              code
              name
            }
            validSizes {
              code
              name
            }
            validRubricCodes
          }
        }
      }
    }
  `;

  const data = await exec<CatalogAttributesExecVariables, CatalogAttributesExecResponse>(
    searchQuery,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    }
  );
  return data.restUser.partner.catalogAttributes;
};
